import { gql } from "@apollo/client";

export const CREATE_USER_MUTATION = gql`
mutation CreateUser($userDataInput: UserInput) {
  createUser(userDataInput: $userDataInput) {
    createdAt
  }
}
`;
export const DELETE_USER_MUTATION = gql`
mutation DeleteUser($deleteUserId: ID) {
  deleteUser(id: $deleteUserId)
}`
export const UPDATE_USER_MUTATION = gql`
mutation UpdateUser($updateUserId: ID, $updateUserDataInput: UserInput) {
  updateUser(id: $updateUserId, updateUserDataInput: $updateUserDataInput) {
    _id
    address {
      country
      state
      city
    }
    createdAt
    date_of_birth
    email
    fullName
    phone
    updatedAt
    userDetails {
      image
      _id
      organization {
        organizationName
      }
      profession
    }
    userType
  }
}
`;

export const RESET_PASSWORD_MUTATION = gql`
mutation ResetPassword($email: String!) {
  resetPassword(email: $email)
}`

export const CREATE_FORM_MUTATION = gql`
mutation CreateForm($formData: FormInput) {
  createForm(formsData: $formData) {
    _id
    createdAt
    description
    formStatus
    formTitle
    updatedAt
  }
}`
export const UPDATE_FORM_MUTATION = gql`
mutation UpdateForm($updateFormId: ID, $updateFormDataInput: FormInput) {
  updateForm(id: $updateFormId, updateFormDataInput: $updateFormDataInput) {
    formStatus
    formTitle
    formType
    questions {
      questionType
      id
      questionMetadata {
        max
        min
        choices
      }
      questionTitle
      required
    }
    updatedAt
    _id
    formMetadata {
      theme {
        color
        font
        image
      }
    }
  }
}`

export const DELETE_FORM_MUTATION = gql`
mutation DeleteForm($deleteFormId: ID) {
  deleteForm(id: $deleteFormId)
}`


export const UPDATE_FORM_METADATA_UPDATE_MUTATION = gql`
mutation UpdateForm($updateFormId: ID, $updateFormDataInput: FormInput) {
  updateForm(id: $updateFormId, updateFormDataInput: $updateFormDataInput) {
    createdAt
    formMetadata {
      theme {
        color
        font
        image
      }
      visibility
    }
  }
}`

export const CREATE_FORM_RESPONSE = gql`
mutation CreateResponse($formId: ID, $responseData: ResponseInput) {
  createResponse(formId: $formId, responseData: $responseData) {
    formId
    responses {
      userId
      response {
        questionId
        responseText
      }
    }
  }
}`

export const CREATE_ANON_RESPONSE = gql`
mutation AnonymousResponses($formId: ID, $anonymousResponseData: AnonumousResponseInput) {
  anonymousResponses(formId: $formId, anonymousResponseData: $anonymousResponseData) {
    formId
    responses {
      questionId
      responseText
    }
  }
}`

export const UPDATE_USER_PASSWORD_MUTATION = gql`
mutation UpdateUserPassword($resetToken: String, $newPassword: String) {
  updateUserPassword(resetToken: $resetToken, newPassword: $newPassword) {
    _id
  }
}`



export const REQUEST_FORM_SURVEYOR_MUTATATION = gql`
mutation RequestFormSurveyor($requestFormData: RequestFormInput) {
  requestFormSurveyor(requestFormData: $requestFormData) {
    _id
    createdAt
    description
    formTitle
    formType
    questions {
      questionType
      questionTitle
      questionMetadata
    }
    requestedSurveyor {
      email
      fullName
      phone
    }
    updatedAt
  }
}`

export const ASSIGN_SURVEYOR_FORM = gql`
mutation AssignAdminForm($assignAdminFormId: ID, $adminEmail: String) {
  assignAdminForm(id: $assignAdminFormId, adminEmail: $adminEmail) {
    _id
    assignedAdmin
  }
}`

export const GET_ANALYTICS = gql`
query GetQuestionResponses($getQuestionResponsesId: ID) {
  getQuestionResponses(id: $getQuestionResponsesId) {
    corResponse
    questionTitle
  }
}`